import { useMemo } from "react";
import { Dialog } from "cerulean";
import { useLocation, useNavigate, matchRoutes } from "react-router-dom";
import { useLocalization } from "@fluent/react";
import { useSudoContext } from "../SudoContext";
import { SudoEventEmitter, SudoEvents } from "../SudoContext/events";
import RequestOTP from "../SudoContext/RequestOTP";
import SubmitOTP from "../SudoContext/SubmitOTP";

const SudoDialog = () => {
  const {
    originalRoute,
    requestOtpRoute,
    submitOtpRoute,
    onCancel,
    closeRouteOverride
  } = useSudoContext();
  const location = useLocation();
  const navigate = useNavigate();
  const { l10n } = useLocalization();

  const handleClose = () => {
    // Emit cancelled event when dialog is closed
    SudoEventEmitter.emit(SudoEvents.CANCELLED);
    onCancel?.();
    const target = closeRouteOverride || originalRoute;
    if (target) {
      navigate(target);
    }
  };

  // Determine if the current route is a Sudo route
  const isRequestOtpRoute = useMemo(
    () => matchRoutes([{ path: requestOtpRoute }], location.pathname),
    [location.pathname]
  );
  const isSubmitOtpRoute = useMemo(
    () => matchRoutes([{ path: submitOtpRoute }], location.pathname),
    [location.pathname]
  );
  const isSudoRoute = isRequestOtpRoute || isSubmitOtpRoute;

  return (
    <Dialog
      isOpen={!!isSudoRoute}
      onUserDismiss={handleClose}
      width="385px"
      title={
        isRequestOtpRoute
          ? l10n.getString(
              "heading-verify-account",
              null,
              "Let's verify your account"
            )
          : l10n.getString(
              "heading-enter-verification-code",
              null,
              "Enter verification code"
            )
      }
    >
      {isRequestOtpRoute && <RequestOTP isInDialog />}
      {isSubmitOtpRoute && <SubmitOTP isInDialog />}
    </Dialog>
  );
};

export default SudoDialog;
